"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlFloatAttribute = void 0;
const a_gl_attribute_1 = require("./a-gl-attribute");
/**
 * @public
 * A Float32 {@link IGlAttribute}.
 */
class GlFloatAttribute extends a_gl_attribute_1.AGlAttribute {
    getGlType(context) {
        return context.FLOAT;
    }
}
exports.GlFloatAttribute = GlFloatAttribute;
//# sourceMappingURL=gl-float-attribute.js.map